module.exports = __webpack_public_path__ + "static/media/al.34a9d8d0.jpg";